import Http from 'utils/http'
import store from 'store/index'

export const getAll = () => Http.get(`/integrations`)

export const getICal = () => Http.get(`/integrations/ical`)

export const disableICal = () => Http.delete(`/integrations/ical`)

export const enableICal = () => Http.post(`/integrations/ical`)

export const refreshICal = () => Http.put(`/integrations/ical`)

export const getZapier = () => Http.get(`/integrations/zapier-setup`)

export const enableZapier = () => Http.post(`/integrations/zapier-setup`)

export const refreshZapier = () => Http.put(`/integrations/zapier-setup`)

export const disableZapier = () => Http.delete(`/integrations/zapier-setup`)

export const getAllFacebookLeads = () => Http.get(`/integrations/facebook-leads`)

export const getFacebookLeads = (id) => Http.get(`/integrations/facebook-leads/${id}`)

export const createFacebookLeads = (payload) => Http.post(`/integrations/facebook-leads`, payload)

export const updateFacebookLeads = (id, payload) => Http.put(`/integrations/facebook-leads/${id}`, payload)

export const destroyFacebookLeads = (id) => Http.delete(`/integrations/facebook-leads/${id}`)

export const getAllInForms = () => Http.get(`/integrations/informs`)

export const getInForms = (id) => Http.get(`/integrations/informs/${id}`)

export const createInForms = (payload) => Http.post(`/integrations/informs`, payload)

export const updateInForms = (id, payload) => Http.put(`/integrations/informs/${id}`, payload)

export const destroyInForms = (id) => Http.delete(`/integrations/informs/${id}`)

export const enableMailTrap = (payload) => {
    return Http.post(`/integrations/mail-trap`, payload)
       .then(response => {
           store.dispatch('setTenant', response.data)
           return response.data
       })
}

export const updateMailTrap = (payload) => {
    return Http.put(`/integrations/mail-trap`, payload)
       .then(response => {
           store.dispatch('setTenant', response.data)
           return response.data
       })
}

export const enableRdStationToken = (payload) => {
    return Http.post(`/integrations/rd-station`, payload)
       .then(response => {
           store.dispatch('setIntegrations', response.data.integrations)
           return response.data
       })
}

export const updateRdStationToken = (id, payload) => Http.put(`/integrations/rd-station/${id}`, payload)

export const destroyRdStation = (id) => Http.delete(`/integrations/rd-station/${id}`)



// WEBPACK FOOTER //
// ./src/services/integrations.js